import { RootState } from "../../app/Store";

export const selectTheme = (state: RootState) => state.application.theme;
export const selectFontSize = (state: RootState) => state.application.fontSize;
export const selectEnableStallFlag = (state: RootState) =>
  state.application.enableStallPrevention;
